import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { delay } from "@Shared/utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NotificationPopover",
  props: {
    type: {
      type: String,
      default: "default",
      validator(value) {
        const validActions = ["default", "success", "error", "warning", "info"];
        return _includesInstanceProperty(validActions).call(validActions, value);
      }
    },
    title: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "top"
    },
    container: {
      type: String,
      default: ""
    },
    triggers: {
      type: String,
      default: "hover"
    },
    boundary: {
      type: String,
      default: "viewport"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    keepOpen: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      modalIsShown: false,
      localShow: this.show,
      // we need have a flag for the delay after mounted [DON'T TOUCH THIS]
      containerReady: false,
      // and one after the next tick after mounted [DON'T TOUCH THIS]
      componentReady: false
    };
  },
  computed: {
    getCustomClass() {
      let typeClasses = [];
      if (this.type === "error") typeClasses.push("generic-popover-error");
      if (this.type === "success") typeClasses.push("generic-popover-success");
      if (this.type === "warning") typeClasses.push("generic-popover-warning");
      if (this.type === "info") typeClasses.push("generic-popover-info");
      return [...typeClasses, this.customClass].join(" ");
    },
    popoverShown: {
      get() {
        if (this.modalIsShown) return false;
        if (this.keepOpen) return true;
        return this.localShow;
      },
      set(val) {
        this.localShow = val;
        this.$emit("update:show", val);
      }
    },
    popoverTriggers() {
      if (this.keepOpen) return "manual";
      return this.triggers;
    }
  },
  watch: {
    show(show, oldVal) {
      // taken from https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/src/components/tooltip/tooltip.js
      if (show !== oldVal && show !== this.popoverShown) {
        this.popoverShown = show;
      }
    },
    localShow(value) {
      this.$emit(value ? "show" : "hide");
    }
  },
  async mounted() {
    this.bindModalEvents();
    await delay(100);
    this.containerReady = true;
    await this.$nextTick();
    this.componentReady = true;
  },
  beforeDestroy() {
    this.unbindModalEvents();
  },
  methods: {
    handleGlobalShow() {
      this.modalIsShown = true;
    },
    handleGlobalHidden() {
      this.modalIsShown = false;
    },
    bindModalEvents() {
      this.$root.$on("bv::modal::show", this.handleGlobalShow);
      this.$root.$on("bv::modal::hidden", this.handleGlobalHidden);
    },
    unbindModalEvents() {
      this.$root.$off("bv::modal::show", this.handleGlobalShow);
      this.$root.$off("bv::modal::hidden", this.handleGlobalHidden);
    }
  }
});